import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CloseIcon } from "../components/CloseIcon";
import {
  Search,
  SlidersHorizontal,
  RotateCcw,
  LayoutGrid,
  Globe,
  Smartphone,
  Code,
  ExternalLink,
  Filter,
  Eye,
  Briefcase,
  Layers,
  ShoppingBag,
  Cpu,
  Download
} from "lucide-react";

export interface PortfolioItem {
  id: number;
  category: string;
  title: string;
  descriptions: string;
  urldescriptions: string;
  imageUrl: string;
  url?: string;
  androidUrl?: string;
  iosUrl?: string;
  isActive?: boolean;
}

// Portfolio Dataset (47 Client Items with Local Assets & Working Live Links)
export const CARDS_DATA: PortfolioItem[] = [
  {
    id: 1,
    category: 'wordpress',
    title: 'BANDAARI MEDICAL SERVICES',
    descriptions: 'Bandaari Medical Services is a distinguished leader in the realm of medical tourism.',
    urldescriptions: 'bandariglobalhealthcare.com',
    imageUrl: '/assets/portfolio/all/bhandari.webp',
    url: 'https://bandariglobalhealthcare.hickter.com/'
  },
  {
    id: 2,
    category: 'wordpress',
    title: 'Brother Printer Service',
    descriptions: 'We Have Well Qualified Specialists To Handle Your Toner Cartridges.',
    urldescriptions: 'brotherprinterservicecenter.com',
    imageUrl: '/assets/portfolio/all/brother.webp',
    url: 'https://brotherprinterservicecenter.com/'
  },
  {
    id: 3,
    category: 'shopify',
    title: 'Tanabanabyaparna',
    descriptions: 'Clothing and Handmade Items stores offer a unique shopping experience.',
    urldescriptions: 'tanabanabyaparna.com',
    imageUrl: '/assets/portfolio/all/tanaabana.webp',
    url: 'https://www.tanabanabyaparna.com/'
  },
  {
    id: 4,
    category: 'shopify',
    isActive: false,
    title: 'Aradhyahandloom',
    descriptions: 'Ecommerce Store for clothing brand that provide saree, kurtis, etc.',
    urldescriptions: 'aradhyahandloom.com',
    imageUrl: '/assets/portfolio/all/aradhya.webp',
    url: 'https://aradhyahandloom.com/'
  },
  {
    id: 5,
    category: 'shopify',
    title: 'Fiji Water – Brand Site',
    descriptions: 'FIJI Water has been committed to doing business responsibly and seeking opportunities.',
    urldescriptions: 'fijiwater.com',
    imageUrl: '/assets/portfolio/all/fiji.webp',
    url: 'https://www.fijiwater.com/'
  },
  {
    id: 6,
    category: 'php',
    title: 'Asset Homes – Real estate Home',
    descriptions: 'We are home builders We have a unique selection of apartments, flats, and villas.',
    urldescriptions: 'assethomes.in',
    imageUrl: '/assets/portfolio/all/asset.webp',
    url: 'https://www.assethomes.in/'
  },
  {
    id: 7,
    category: 'wordpress',
    title: 'Magzonindia | Fertilizer Agriculture',
    descriptions: 'Micro Nutrient Fertilizer, Soil Fungus And Bacterial Control in India.',
    urldescriptions: 'magzonindia.com',
    imageUrl: '/assets/portfolio/all/magzonindia.webp',
    url: 'https://www.magzonindia.com/'
  },
  {
    id: 8,
    category: 'woocommerce',
    title: 'Brand Baket | Consumer Brand',
    descriptions: 'Consumer Brand offer a unique shopping best brand products available.',
    urldescriptions: 'brandbasket.store',
    imageUrl: '/assets/portfolio/all/brandbasket.webp',
    url: 'https://feelingsforyou.in/'
  },
  {
    id: 9,
    category: 'wordpress',
    title: 'ISYX Tech – Tech Solution',
    descriptions: 'Global Offices, we help businesses to impact on their customers.',
    urldescriptions: 'isyxtech.com',
    imageUrl: '/assets/portfolio/all/isyxtech.webp',
    url: 'https://isyxtech.com/'
  },
  {
    id: 10,
    category: 'wordpress',
    title: 'Hotel Prince | Hotel & Room Booking',
    descriptions: 'This hotel in Odisha offer a number of benefits to customers.',
    urldescriptions: 'hotelprince.in',
    imageUrl: '/assets/portfolio/all/hp.webp',
    url: 'https://hotelprince.in/'
  },
  {
    id: 11,
    category: 'wordpress',
    title: 'Voxtron | Digital Solution',
    descriptions: 'Application development company with 20+ years of experience, we build highly secure systems.',
    urldescriptions: 'voxtronme.com',
    imageUrl: '/assets/portfolio/all/voxtron.webp',
    url: 'https://www.voxtronme.com/'
  },
  {
    id: 12,
    category: 'react',
    title: 'Money Vision | Mutual Fund',
    descriptions: 'Mutual fund apps offer a number of benefits to investors of all experience levels.',
    urldescriptions: 'moneyvision.in',
    imageUrl: '/assets/portfolio/all/mv.webp',
    url: 'https://moneyvision.in/'
  },
  {
    id: 13,
    category: 'wordpress',
    title: 'BookMyFirstHome | Rent, Buy Home',
    descriptions: 'BookMyFirstHome is a fantastic platform for finding and booking homes locally.',
    urldescriptions: 'bookmyfirsthome.com',
    imageUrl: '/assets/portfolio/all/bookmyhome.webp',
    url: 'https://bookmyfirsthome.com/'
  },
  {
    id: 14,
    category: 'php',
    title: 'Luxury Perfume | Brand',
    descriptions: 'This is the best place to buy perfumes and colognes online.',
    urldescriptions: 'luxuryperfume.com',
    imageUrl: '/assets/portfolio/all/luxeryperfume.webp',
    url: 'https://luxuryperfume.com/'
  },
  {
    id: 15,
    category: 'wordpress',
    title: 'FRATERNITY TECHNOCRATS',
    descriptions: 'Fraternity Technocrats encourage our community to be environmentally conscious.',
    urldescriptions: 'fraternitytechnocrats.com',
    imageUrl: '/assets/portfolio/all/ft.webp',
    url: 'https://www.fraternitytechnocrats.com/'
  },
  {
    id: 16,
    category: 'wordpress',
    title: 'MedTour Health',
    descriptions: 'MedTour Health Expo is more than an event—it’s a movement transforming healthcare.',
    urldescriptions: 'medtourhealthexpo.com',
    imageUrl: '/assets/portfolio/all/medtourexpo.webp',
    url: 'https://medtourhealthexpo.com/'
  },
  {
    id: 17,
    category: 'wordpress',
    title: 'Auragoa | SPA & Living',
    descriptions: 'This wellness oasis is an hour and a half’s drive from Goa International Airport.',
    urldescriptions: 'auragoa.com',
    imageUrl: '/assets/portfolio/all/auraspa.webp',
    url: 'https://auragoa.com/'
  },
  {
    id: 18,
    category: 'react',
    title: 'Jersey Group | Projects Builder',
    descriptions: 'Jersey Group is one amongst the foremost group of companies.',
    urldescriptions: 'jerseygroup.com',
    imageUrl: '/assets/portfolio/all/jerseygc.webp',
    url: 'https://www.jerseygroup.com/'
  },
  {
    id: 19,
    category: 'apps',
    title: 'DreamCart - WooCommerce App',
    descriptions: 'WooCommerce mobile app solution that transforms your online Store',
    urldescriptions: 'Google Play & App Store',
    imageUrl: '/assets/portfolio/all/Dreamcart.webp',
    url: 'https://play.google.com/store/apps/details?id=com.mrblab.dreamcart',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.mrblab.dreamcart',
    iosUrl: 'https://apps.apple.com/us/app/dreamcart-woocommerce/id6751768630'
  },
  {
    id: 20,
    category: 'apps',
    title: 'Cirilla - Multipurpose App',
    descriptions: 'Multi-purpose app for woocommerce store',
    urldescriptions: 'Google Play & App Store',
    imageUrl: '/assets/portfolio/all/CRILLA.webp',
    url: 'https://play.google.com/store/apps/details?id=io.rnlab.cirilla',
    androidUrl: 'https://play.google.com/store/apps/details?id=io.rnlab.cirilla',
    iosUrl: 'https://apps.apple.com/us/app/cirilla-store/id1498754090'
  },
  {
    id: 21,
    category: 'apps',
    title: 'Detergent Shop App - E-commerce',
    descriptions: 'E-commerce Store app in Flutter (Android) with WooCommerce Full App',
    urldescriptions: 'Google Play Store',
    imageUrl: '/assets/portfolio/all/Detergent.webp',
    url: 'https://templatevilla.net/codecanyon/wordpress/detergentshop_app/detergent_shop_app.apk',
    androidUrl: 'https://templatevilla.net/codecanyon/wordpress/detergentshop_app/detergent_shop_app.apk',
    iosUrl: '#'
  },
  {
    id: 22,
    category: 'woocommerce',
    title: 'KB Electronics',
    descriptions: 'K.B and traders of optimum quality Projector/LED Mounts, USB, VGA, and HDMI Cable etc.',
    urldescriptions: 'kbelectronics.in',
    imageUrl: '/assets/portfolio/all/kb.webp',
    url: 'https://www.kbelectronics.in/'
  },
  {
    id: 23,
    category: 'woocommerce',
    title: 'Somdev',
    descriptions: 'Leading manufacturers & service providers of all types of LT Control Panels',
    urldescriptions: 'somdevco.in',
    imageUrl: '/assets/portfolio/all/somdev.webp',
    url: 'https://somdevco.in/our-products/'
  },
  {
    id: 24,
    category: 'react',
    title: 'Goldexa',
    descriptions: 'Your one-stop destination for selling old gold, availing EMI options, and renting gold.',
    urldescriptions: 'goldexa.in',
    imageUrl: '/assets/portfolio/all/goldexa.webp',
    url: 'https://goldexa.in/'
  },
  {
    id: 25,
    category: 'wordpress',
    title: 'Sidhipurnanutrition',
    descriptions: 'Sidhipurna Nutrition & Wellness Clinic, science-based, personalized nutrition guidance.',
    urldescriptions: 'sidhipurnanutrition.com',
    imageUrl: '/assets/portfolio/all/sidhipurnanutrition.webp',
    url: 'https://sidhipurnanutrition.com/'
  },
  {
    id: 26,
    category: 'woocommerce',
    title: 'Fashionable Mart',
    descriptions: 'At Fashionable Mart, we believe fashion is more than clothing—it’s a lifestyle.',
    urldescriptions: 'fashionablemart.com',
    imageUrl: '/assets/portfolio/all/fashionablemart.webp',
    url: 'https://fashionablemart.hickter.com/'
  },
  {
    id: 27,
    category: 'shopify',
    title: 'Vitalydesign',
    descriptions: 'Established in 2011 and based in Toronto, Vitaly produces engineered accessories using stainless steel.',
    urldescriptions: 'vitalydesign.com',
    imageUrl: '/assets/portfolio/all/vitalydesign.png',
    url: 'https://www.vitalydesign.com/'
  },
  {
    id: 28,
    category: 'shopify',
    title: 'Mejuri',
    descriptions: 'Our journey mirrors that of the jewelry we create—crafted through collaboration and constant evolution.',
    urldescriptions: 'mejuri.com',
    imageUrl: '/assets/portfolio/all/mejuri.webp',
    url: 'https://mejuri.com/'
  },
  {
    id: 29,
    category: 'shopify',
    title: 'Effy Jewelry',
    descriptions: 'From initial sketch to final polished design, each beautifully crafted piece maintains highest standards.',
    urldescriptions: 'effyjewelry.com',
    imageUrl: '/assets/portfolio/all/effyjewelry.webp',
    url: 'https://www.effyjewelry.com/'
  },
  {
    id: 30,
    category: 'shopify',
    title: 'Hazoorilal Legacy',
    descriptions: 'A manufacturer, a retailer, a craftsman – Shri Hazoorilal ji was a man of all seasons.',
    urldescriptions: 'hazoorilallegacy.com',
    imageUrl: '/assets/portfolio/all/hazoorilallegacy.webp',
    url: 'https://www.hazoorilallegacy.com/'
  },
  {
    id: 31,
    category: 'shopify',
    title: 'Metro Shoes',
    descriptions: 'Lone shoe store opened its doors to the public in Colaba, Mumbai. Metro Shoes is a household name.',
    urldescriptions: 'metroshoes.com',
    imageUrl: '/assets/portfolio/all/metroshoes.webp',
    url: 'https://www.metroshoes.com/'
  },
  {
    id: 32,
    category: 'shopify',
    title: 'Peachmode',
    descriptions: 'Peachmode creates contemporary Indian wear that blends timeless craftsmanship with modern silhouettes.',
    urldescriptions: 'peachmode.com',
    imageUrl: '/assets/portfolio/all/peachmode.webp',
    url: 'https://www.peachmode.com/'
  },
  {
    id: 33,
    category: 'shopify',
    title: 'Pureseeds',
    descriptions: 'PureSeeds.store is an online platform offering high-quality seeds for gardening and farming enthusiasts.',
    urldescriptions: 'pureseeds.com',
    imageUrl: '/assets/portfolio/all/pureseeds.webp',
    url: 'https://pureseeds.store/'
  },
  {
    id: 34,
    category: 'woocommerce',
    title: 'The Fashion Station',
    descriptions: 'The Fashion Station is an India-based business operating in compliance with applicable Indian laws.',
    urldescriptions: 'thefashionstation.in',
    imageUrl: '/assets/portfolio/all/thefashionstation.webp',
    url: 'https://thefashionstation.in/'
  },
  {
    id: 35,
    category: 'woocommerce',
    title: 'Aditri',
    descriptions: 'Sanskrit name for ‘Goddess Lakshmi’ symbolizing prosperity, wealth, creativity & elegance.',
    urldescriptions: 'aditri.co.in',
    imageUrl: '/assets/portfolio/all/aditri.webp',
    url: 'https://aditri.co.in/'
  },
  {
    id: 36,
    category: 'woocommerce',
    title: 'Thecaistore',
    descriptions: 'CAI is the brainchild of Aradhana & Dhanraj Minawala, shaping an extraordinary trend in footwear.',
    urldescriptions: 'thecaistore.com',
    imageUrl: '/assets/portfolio/all/thecaistore.webp',
    url: 'https://thecaistore.com/'
  },
  {
    id: 37,
    category: 'woocommerce',
    title: 'Puresourceindia',
    descriptions: 'Established in the year 2007, at the heart India (New Delhi), we Pure Source India.',
    urldescriptions: 'puresourceindia.in',
    imageUrl: '/assets/portfolio/all/puresourceindia.webp',
    url: 'https://puresourceindia.in/'
  },
  {
    id: 38,
    category: 'woocommerce',
    title: 'Tiesta',
    descriptions: 'Tiesta is a brand that offers a wide range of high-quality products for everyday use.',
    urldescriptions: 'tiesta.in',
    imageUrl: '/assets/portfolio/all/tiesta.webp',
    url: 'https://tiesta.in/'
  },
  {
    id: 39,
    category: 'wordpress',
    title: 'Bhagabati Engineering Solution',
    descriptions: 'A Trusted Partner to Industry Leaders Our 5-year reputation is built on trust.',
    urldescriptions: 'bhagabatiengineeringsolution.in',
    imageUrl: '/assets/portfolio/all/bes.webp',
    url: 'https://bhagabatiengineeringsolution.in/'
  },
  {
    id: 40,
    category: 'php',
    title: 'GraphicsZilla',
    descriptions: 'At GraphicsZilla, we\'re on a mission to redefine your printing experience with competitive pricing.',
    urldescriptions: 'graphicszilla.com',
    imageUrl: '/assets/portfolio/all/graphicszilla.webp',
    url: 'https://www.graphicszilla.com/'
  },
  {
    id: 41,
    category: 'react',
    title: 'Showstopper',
    descriptions: 'In the heart of India’s vibrant textile industry, two entrepreneurs created a brand.',
    urldescriptions: 'showstopper.com',
    imageUrl: '/assets/portfolio/all/showstopper.webp',
    url: 'https://www.showstopper.co.in/'
  },
  {
    id: 42,
    category: 'react',
    title: 'Thaiger Pharma',
    descriptions: 'Thaiger Pharma Group specializes in manufacturing and distributing high-quality generic pharma products.',
    urldescriptions: 'thaiger-pharma.com',
    imageUrl: '/assets/portfolio/all/thaiger-pharma.webp',
    url: 'https://thaiger-pharma.com/'
  },
  {
    id: 43,
    category: 'react',
    title: 'Binfinit',
    descriptions: 'We transform commodities by bridging the gap between regions of abundance and demand.',
    urldescriptions: 'binfinit.com',
    imageUrl: '/assets/portfolio/all/binfinit.webp',
    url: 'https://binfinit.co/'
  },
  {
    id: 44,
    category: 'shopify',
    title: 'Kala Vogue',
    descriptions: 'Ethnic Wear Brand offering handcrafted sarees, traditional wear, and festive fashion.',
    urldescriptions: 'kalavogue.com',
    imageUrl: '/assets/portfolio/all/kalavogue.webp',
    url: 'https://kalavogue.com/'
  },
  {
    id: 45,
    category: 'shopify',
    title: 'Karagiri Sarees',
    descriptions: 'Premium ethnic fashion destination for designer sarees, bridal wear, and lehengas.',
    urldescriptions: 'karagiri.com',
    imageUrl: '/assets/portfolio/all/karagiri.webp',
    url: 'https://www.karagiri.com/'
  },
  {
    id: 46,
    category: 'woocommerce',
    title: 'Sitaram Stationers',
    descriptions: 'Leading supplier of professional art supplies, stationery, and creative drafting materials.',
    urldescriptions: 'sitaramstationers.com',
    imageUrl: '/assets/portfolio/all/sitaramstationers.webp',
    url: 'https://www.sitaramstationers.com/'
  },
  {
    id: 47,
    category: 'shopify',
    title: 'Truffle Collection',
    descriptions: 'Trendy footwear and handbag brand offering international fashion styles online.',
    urldescriptions: 'trufflecollection.co.in',
    imageUrl: '/assets/portfolio/all/trufflecollection.webp',
    url: 'https://trufflecollection.co.in/'
  }
];

export default function PortfolioPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [activeProject, setActiveProject] = useState<PortfolioItem | null>(null);

  // Filter Items Based on User Inputs
  const filteredProjects = CARDS_DATA.filter((item) => {
    const matchesSearch =
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.descriptions.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.urldescriptions.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesCategory =
      selectedCategory === "all" || item.category.toLowerCase() === selectedCategory.toLowerCase();

    return matchesSearch && matchesCategory;
  });

  const categories = [
    { id: "all", name: "All Projects", icon: <LayoutGrid size={14} /> },
    { id: "wordpress", name: "WordPress", icon: <Globe size={14} /> },
    { id: "shopify", name: "Shopify", icon: <ShoppingBag size={14} /> },
    { id: "woocommerce", name: "WooCommerce", icon: <Layers size={14} /> },
    { id: "react", name: "React", icon: <Cpu size={14} /> },
    { id: "php", name: "PHP", icon: <Code size={14} /> },
    { id: "apps", name: "Mobile Apps", icon: <Smartphone size={14} /> },
  ];

  const resetFilters = () => {
    setSelectedCategory("all");
    setSearchQuery("");
  };

  const getTargetUrl = (project: PortfolioItem) => {
    if (project.category === "apps") {
      return project.androidUrl || project.iosUrl || project.url || "#";
    }
    return project.url || "#";
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 antialiased selection:bg-blue-600 selection:text-white transition-colors duration-300 font-body">
      
      {/* ================= SEARCH & CATEGORY BAR (STICKY AT TOP-0) ================= */}
      <div className="sticky top-0 z-50 bg-white/95 dark:bg-slate-900/95 backdrop-blur-md border-b border-slate-200 dark:border-slate-800 shadow-md">
        {/* Category Horizontal Filter Bar */}
        <div className="border-b border-slate-200 dark:border-slate-800/60 px-4 py-2 flex items-center overflow-x-auto no-scrollbar">
          <div className="max-w-7xl w-full mx-auto flex items-center gap-2">
            {categories.map((cat) => {
              const isSelected = selectedCategory === cat.id;
              return (
                <button
                  key={cat.id}
                  onClick={() => setSelectedCategory(cat.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-extrabold transition-all whitespace-nowrap cursor-pointer font-heading ${
                    isSelected
                      ? "!text-white dark:!text-white bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-500 dark:to-indigo-500 shadow-md shadow-blue-600/30 border border-blue-400/30 scale-102"
                      : "text-slate-700 dark:text-slate-300 hover:text-slate-950 dark:hover:text-white bg-slate-100/90 dark:bg-slate-800/80 hover:bg-slate-200 dark:hover:bg-slate-700/90 border border-slate-200/80 dark:border-slate-700/70"
                  }`}
                >
                  <span className={isSelected ? "!text-white dark:!text-white" : "text-blue-600 dark:text-cyan-400"}>
                    {cat.icon}
                  </span>
                  <span className={isSelected ? "!text-white dark:!text-white font-extrabold" : ""}>
                    {cat.name}
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Search Input Bar */}
        <div className="px-4 sm:px-6 h-14 flex items-center">
          <div className="max-w-7xl w-full mx-auto flex items-center justify-between gap-3">
            <div className="relative flex-1 max-w-md">
              <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search by title, technology or domain..."
                className="w-full bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 text-xs font-medium pl-10 pr-4 py-2 rounded-xl border border-slate-300 dark:border-slate-800 focus:border-blue-600 outline-none transition-all placeholder-slate-400 dark:placeholder-slate-500 shadow-xs"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-900 dark:hover:text-white cursor-pointer"
                >
                  <CloseIcon size="16px" />
                </button>
              )}
            </div>

            {/* Mobile Filter Drawer Toggle Button */}
            <button
              onClick={() => setIsFilterOpen(true)}
              className="sm:hidden flex items-center gap-2 bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-900 dark:text-white px-3 py-2 rounded-xl text-xs font-bold active:scale-95 transition-transform cursor-pointer font-heading shadow-xs"
            >
              <SlidersHorizontal size={14} />
              <span>Filter</span>
            </button>
          </div>
        </div>
      </div>

      {/* ================= PORTFOLIO MAIN GRID ================= */}
      <main className="py-10 px-4 sm:px-6 max-w-7xl mx-auto">
        
        {/* HEADER */}
        <div className="mb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-4 border-b border-slate-200 dark:border-slate-800/80 pb-4">
          <div>
            <div className="flex items-center gap-2 text-blue-600 dark:text-blue-500 mb-1">
              <Briefcase size={16} />
              <span className="text-xs font-black uppercase tracking-widest font-heading">Our Work</span>
            </div>
            <h1 className="text-2xl sm:text-4xl font-extrabold text-slate-950 dark:text-white tracking-tight font-heading">
              Client Showcase
            </h1>
          </div>
          <span className="text-xs font-bold text-slate-600 dark:text-slate-400 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 px-3 py-1.5 rounded-lg shrink-0 font-heading shadow-xs">
            Showing {filteredProjects.length} of {CARDS_DATA.length} Projects
          </span>
        </div>

        {/* GRID */}
        {filteredProjects.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                className="group glass-card rounded-2xl overflow-hidden flex flex-col justify-between"
              >
                {/* IMAGE WITH INDIVIDUAL UNIQUE URL & CLICKABLE LINK */}
                <a
                  href={getTargetUrl(project)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="relative aspect-video overflow-hidden bg-slate-100 dark:bg-slate-950 border-b border-slate-200 dark:border-slate-800 block cursor-pointer"
                >
                  <img
                    src={project.imageUrl}
                    alt={project.title}
                    onError={(e: any) => {
                      e.target.onerror = null;
                      e.target.src = "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80";
                    }}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 bg-white/90 dark:bg-slate-950/80 backdrop-blur-xs text-blue-600 dark:text-blue-400 text-[10px] font-black uppercase tracking-wider px-2.5 py-1 rounded-md border border-slate-200 dark:border-slate-800 font-heading shadow-xs">
                    {project.category}
                  </div>
                </a>

                {/* CONTENT */}
                <div className="p-5 flex-1 flex flex-col justify-between space-y-4">
                  <div>
                    <a
                      href={getTargetUrl(project)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-base font-bold text-slate-950 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 transition-colors line-clamp-1 font-heading block"
                    >
                      {project.title}
                    </a>
                    <p className="text-xs text-slate-600 dark:text-slate-400 mt-2 line-clamp-2 leading-relaxed font-medium">
                      {project.descriptions}
                    </p>
                  </div>

                  <div className="space-y-3 pt-2">
                    <span className="text-[11px] font-mono text-slate-500 truncate block">
                      {project.urldescriptions}
                    </span>

                    <div className="flex gap-2">
                      <button
                        onClick={() => setActiveProject(project)}
                        className="flex-1 flex items-center justify-center gap-1.5 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 text-slate-900 dark:text-white text-xs font-bold py-2 rounded-xl transition-all cursor-pointer font-heading border border-slate-200 dark:border-slate-700"
                      >
                        <Eye size={14} />
                        <span>Details</span>
                      </button>

                      {project.category === "apps" ? (
                        <a
                          href={project.androidUrl || project.iosUrl || project.url || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 flex items-center justify-center gap-1.5 cyber-btn-primary text-xs py-2"
                        >
                          <Download size={14} />
                          <span>Get App</span>
                        </a>
                      ) : (
                        <a
                          href={project.url || "#"}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 flex items-center justify-center gap-1.5 cyber-btn-primary text-xs py-2"
                        >
                          <ExternalLink size={14} />
                          <span>Live Site</span>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        ) : (
          /* EMPTY STATE */
          <div className="text-center py-20 bg-white dark:bg-slate-900/50 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs">
            <Filter size={32} className="mx-auto text-slate-400 mb-3" />
            <h3 className="text-base font-bold text-slate-950 dark:text-white font-heading">No projects found</h3>
            <p className="text-xs text-slate-600 dark:text-slate-400 mt-1 max-w-sm mx-auto font-medium">
              No portfolio results match your search parameters. Try adjusting or resetting your filter options.
            </p>
            <button
              onClick={resetFilters}
              className="mt-4 cyber-btn-primary text-xs"
            >
              Reset Search
            </button>
          </div>
        )}
      </main>

      {/* ================= MOBILE BOTTOM SLIDE-UP FILTER ================= */}
      <AnimatePresence>
        {isFilterOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsFilterOpen(false)}
              className="fixed inset-0 bg-black/60 backdrop-blur-xs z-[300] sm:hidden"
            />

            <motion.div
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 250 }}
              className="fixed bottom-0 left-0 right-0 z-[310] bg-white dark:bg-slate-900 rounded-t-3xl border-t border-slate-200 dark:border-slate-800 shadow-2xl overflow-hidden sm:hidden"
            >
              <div className="pt-3 pb-4 px-6 border-b border-slate-200 dark:border-slate-800 flex flex-col items-center">
                <div className="w-12 h-1 bg-slate-300 dark:bg-slate-700 rounded-full mb-3" />
                <div className="w-full flex items-center justify-between">
                  <span className="text-xs font-bold uppercase tracking-wider text-slate-950 dark:text-white font-heading">
                    Select Technology
                  </span>
                  <button
                    onClick={() => setIsFilterOpen(false)}
                    aria-label="Close modal"
                    className="relative z-50 w-9 h-9 rounded-full bg-red-600 hover:bg-red-500 text-white shadow-lg shadow-red-600/40 flex items-center justify-center transition-all cursor-pointer shrink-0 border border-red-400/50 active:scale-95"
                  >
                    <CloseIcon size="18px" style={{ color: "#ffffff" }} />
                  </button>
                </div>
              </div>

              <div className="p-6 space-y-2 max-h-[60vh] overflow-y-auto">
                {categories.map((cat) => {
                  const isSelected = selectedCategory === cat.id;
                  return (
                    <button
                      key={cat.id}
                      onClick={() => {
                        setSelectedCategory(cat.id);
                        setIsFilterOpen(false);
                      }}
                      className={`w-full p-3.5 rounded-xl text-xs font-extrabold transition-all flex items-center gap-3 cursor-pointer font-heading ${
                        isSelected
                          ? "!text-white dark:!text-white bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-blue-500 dark:to-indigo-500 shadow-md shadow-blue-600/30 border border-blue-400/30"
                          : "bg-slate-100 dark:bg-slate-900 text-slate-800 dark:text-slate-200 border border-slate-200 dark:border-slate-800"
                      }`}
                    >
                      <span className={isSelected ? "!text-white dark:!text-white" : "text-blue-600 dark:text-cyan-400"}>
                        {cat.icon}
                      </span>
                      <span className={isSelected ? "!text-white dark:!text-white font-extrabold" : ""}>
                        {cat.name}
                      </span>
                    </button>
                  );
                })}
              </div>

              <div className="p-4 bg-slate-100 dark:bg-slate-950 border-t border-slate-200 dark:border-slate-800 flex items-center gap-3">
                <button
                  onClick={resetFilters}
                  className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-800 text-slate-800 dark:text-slate-300 text-xs font-bold uppercase tracking-wider flex-1 cursor-pointer font-heading"
                >
                  <RotateCcw size={14} />
                  <span>Reset</span>
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* ================= DETAILS MODAL ================= */}
      <AnimatePresence>
        {activeProject && (
          <div className="fixed inset-0 z-[400] flex items-center justify-center p-4 sm:p-6 overflow-y-auto">
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setActiveProject(null)}
              className="fixed inset-0 bg-black/60 backdrop-blur-md"
            />

            {/* Modal Container */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: 10 }}
              transition={{ type: "spring", duration: 0.3 }}
              className="relative w-full max-w-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl z-[410] overflow-hidden shadow-2xl flex flex-col max-h-[85vh] my-auto"
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between px-5 py-3.5 bg-slate-50 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 shrink-0">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md bg-blue-50 dark:bg-blue-600/20 text-blue-600 dark:text-blue-400 border border-blue-200 dark:border-blue-500/30 font-heading">
                    {activeProject.category}
                  </span>
                  <span className="text-xs font-mono text-slate-500 dark:text-slate-400 truncate max-w-[180px] sm:max-w-xs">
                    {activeProject.urldescriptions}
                  </span>
                </div>

                <button
                  onClick={() => setActiveProject(null)}
                  aria-label="Close modal"
                  className="relative z-50 w-9 h-9 rounded-full bg-red-600 hover:bg-red-500 text-white shadow-lg shadow-red-600/40 flex items-center justify-center transition-all cursor-pointer shrink-0 border border-red-400/50 active:scale-95"
                >
                  <CloseIcon size="18px" style={{ color: "#ffffff" }} />
                </button>
              </div>

              {/* Scrollable Modal Content Body */}
              <div className="overflow-y-auto p-5 sm:p-6 space-y-5 flex-1">
                {/* Image Container */}
                <div className="relative aspect-video bg-slate-100 dark:bg-slate-950 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-800">
                  <img
                    src={activeProject.imageUrl}
                    alt={activeProject.title}
                    className="w-full h-full object-cover"
                    onError={(e: any) => {
                      e.target.onerror = null;
                      e.target.src = "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80";
                    }}
                  />
                </div>

                {/* Project Details */}
                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-slate-950 dark:text-white font-heading">{activeProject.title}</h2>
                  <p className="text-xs sm:text-sm text-slate-700 dark:text-slate-300 leading-relaxed mt-2 font-medium">{activeProject.descriptions}</p>
                </div>

                {/* Actions */}
                <div className="pt-4 border-t border-slate-200 dark:border-slate-800 flex gap-3">
                  {activeProject.category === "apps" ? (
                    <>
                      {activeProject.androidUrl && (
                        <a
                          href={activeProject.androidUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 flex items-center justify-center gap-2 bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold py-3 rounded-xl transition-all font-heading"
                        >
                          <Download size={15} />
                          <span>Google Play</span>
                        </a>
                      )}
                      {activeProject.iosUrl && activeProject.iosUrl !== '#' && (
                        <a
                          href={activeProject.iosUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex-1 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white text-xs font-bold py-3 rounded-xl transition-all font-heading"
                        >
                          <Download size={15} />
                          <span>App Store</span>
                        </a>
                      )}
                    </>
                  ) : (
                    <a
                      href={activeProject.url || "#"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full flex items-center justify-center gap-2 cyber-btn-primary text-xs py-3 font-heading"
                    >
                      <ExternalLink size={15} />
                      <span>Visit Live Website</span>
                    </a>
                  )}
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

    </div>
  );
}
